import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiCore } from 'src/app/config/api';
import { ApiService } from 'src/app/core/http/api.service';
import { IWallet } from './interfaces';
import { MobileAgentServiceService } from 'src/app/shared/services/mobile-agent-service.service';

@Component({
  selector: 'app-credits-bonos-info',
  templateUrl: './credits-bonos-info.component.html',
  styleUrls: ['./credits-bonos-info.component.css'],
})
export class CreditsBonosInfoComponent implements OnInit {
  public operator: any;
  public currencyCode: string = '';
  public currencySymbol: string = '';
  public isMobile: boolean = false;

  @Input() public showCredits: boolean = false;
  @Input() public wallet: IWallet = {
    bonus: 0.0,
    credits: 0.0,
  };

  @Output() hideModalMyCredits: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private readonly api: ApiService,
    private readonly messageService: MessageService,
    private readonly mobile: MobileAgentServiceService
  ) {}

  ngOnInit(): void {
    if (!this.operator) {
      this.getoperatorData();
    }

    this.isMobile = this.mobile.isMobileDevice();
  }

  private getoperatorData(): void {
    this.api.list(`${ApiCore.OPERATOR}/operator-config`).subscribe(
      (responseOperator) => {
        if (responseOperator.statusCode != 200) {
          this.messageService.add({
            key: 'bc',
            severity: 'error',
            summary: 'Error loading data',
          });
          return;
        }

        this.operator = responseOperator;
        this.currencyCode = responseOperator.data.currencyCode;
        this.currencySymbol = responseOperator.data.currencySymbol;
      },
      (error) => {
        this.messageService.add({
          key: 'bc',
          severity: 'error',
          summary: JSON.stringify(error),
        });
      }
    );
  }

  public hideMycredits() {
    this.hideModalMyCredits.emit();
  }
}
